import styled from "styled-components";
import {Timeline} from "antd";

export const StyledTimeline = styled(Timeline)`
.ant-timeline-item{
  padding-bottom: 36px;
  
  &:last-child{
    padding-bottom: 0;
  }
  
  &-label{
    left: calc(20% + 14px) !important;
  }
  
  &-tail{
    left: 20% !important;
    top: -24px !important;
    height: calc(200% - 24px) !important;
  }
  
  &-head{
    left: 20% !important;
  }
  
  &-content{
    width: calc(20% - 12px) !important;
  }
}
`